var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    stroke: "#626566",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6934 3.74994H22.6934",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6934 5.99994H22.6934",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6934 8.24994H22.6934",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6934 10.4999H22.6934",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86301 11.7015C9.64098 13.292 10.9302 14.5754 12.5243 15.3461C12.6409 15.4014 12.7699 15.4253 12.8986 15.4156C13.0273 15.4059 13.1512 15.3628 13.2582 15.2906L15.6053 13.7255C15.7091 13.6563 15.8285 13.6141 15.9528 13.6027C16.077 13.5912 16.2021 13.611 16.3168 13.6602L20.7078 15.542C20.857 15.6054 20.9815 15.7155 21.0626 15.8558C21.1438 15.9961 21.1771 16.1589 21.1576 16.3198C21.0189 17.4058 20.489 18.404 19.6672 19.1275C18.8455 19.8509 17.7882 20.25 16.6934 20.2501C13.3118 20.2501 10.0688 18.9068 7.67775 16.5157C5.28666 14.1246 3.94336 10.8816 3.94336 7.50009C3.94342 6.40526 4.34254 5.34798 5.066 4.52623C5.78946 3.70447 6.78764 3.1746 7.87364 3.03581C8.03453 3.01634 8.19739 3.04968 8.33768 3.13082C8.47797 3.21195 8.58809 3.33648 8.65145 3.48564L10.5349 7.88044C10.5837 7.99412 10.6035 8.11808 10.5927 8.24128C10.5819 8.36449 10.5409 8.48311 10.4731 8.58659L8.91347 10.9697C8.84248 11.0769 8.80052 11.2007 8.79167 11.329C8.78283 11.4572 8.80741 11.5856 8.86301 11.7015V11.7015Z",
    stroke: "#626566",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneHistory);
export default __webpack_public_path__ + "static/media/phone-history.c6af8f42f0dde08a50c45e6efb127283.svg";
export { ForwardRef as ReactComponent };